export const processDocumentAttachmentOptions = {
    NOT_ATTACHED: 'NOT_ATTACHED',
    ATTACHED: 'ATTACHED' 
}

export default {
    processDocumentAttachmentOptions
}